import { Color } from 'three';
import { State } from './State';
import { createCoreModules } from './Core';
import { createToolsModule } from './Tools';
import { createDebugModules } from './Debug';
import { createWebglModules } from './Webgl';

import { DEBUG } from './utils/config';
import { EVENTS } from './utils/constants';

export class App {
  /** @type App */
  constructor($parent, params) {
    this.$parent = $parent;
    this.params = params;
  }

  async init() {
    this.state = new State();
    this.core = createCoreModules(this);
    this.tools = createToolsModule(this);
    this.webgl = createWebglModules(this);

    this.coolEffectIntensity = { value: 0 };
    this.particlesEffectIntensity = { value: 0 };

    this.uniforms = {
      uTime: { value: 0.0 },
      uColor: { value: new Color(this.params.color) },
    };

    this.debug = DEBUG && createDebugModules(this);
  }

  async load(assets) {
    await this.core.loader.loadAssets(assets);

    this.state.emit(EVENTS.ATTACH);
    this.state.emit(EVENTS.ATTACHED);
  }

  get viewport() {
    return this.tools.viewport;
  }
}
